import { render, staticRenderFns } from "./carAccidentList.vue?vue&type=template&id=39244a53"
import script from "./carAccidentList.vue?vue&type=script&lang=js"
export * from "./carAccidentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports